
export type FilterTab = 'pairing' | 'processing' | 'ended'

export type Tab = {
  label: string;
  value: FilterTab;
}

export const TABS: Tab[] = [
  {label: '派案中', value: 'pairing'},
  {label: '進行中', value: 'processing'},
  {label: '已結案', value: 'ended'},
]
